import { render, staticRenderFns } from "./NavigationSub.vue?vue&type=template&id=1b6979c0&scoped=true&"
import script from "./NavigationSub.vue?vue&type=script&lang=js&"
export * from "./NavigationSub.vue?vue&type=script&lang=js&"
import style0 from "./NavigationSub.vue?vue&type=style&index=0&id=1b6979c0&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6979c0",
  null
  
)

export default component.exports